import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';
import type { PortType, PortTypeDescription } from '../../types';

export const getPortTypesAPI = () => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/options/port-types`,
    method: 'get',
  });
};

export type PortTypeResponse = {
  disabled: boolean;
  group: null;
  selected: boolean;
  text: PortTypeDescription;
  value: PortType;
}[];

export const fetchPortTypes = async (): Promise<PortTypeResponse> => {
  const response: AxiosResponse<PortTypeResponse> = await getPortTypesAPI();
  return response.data;
};
